<div
  *ngIf="item.children.length > 0 || item.quantity > 0"
  class="d-flex flex-row"
  (mouseenter)="item.selected = true"
  (mouseleave)="item.selected = false"
>
  <div
    class="list-item menu-item"
    style="width: 100%"
    (click)="item.selected = false"
  >
    <div class="row menu-item">
      <div class="col-10">
        <button
          style="background-color: #fff"
          data-toggle="collapse"
          type="button"
          (click)="select(item)"
          class="btn-panel panel-heading-drop {{
            item.selected ? '' : 'collapsed'
          }}"
        >
          {{ item.description }}
        </button>
      </div>
      <div class="col-2 list-item-icon">
        <div *ngIf="item.children.length; else quantityBlock">
          <a class="panel-heading collapsed"></a>
        </div>
        <ng-template #quantityBlock>
          <span class="badge badge-secondary">{{ item.quantity }}</span>
        </ng-template>
      </div>
    </div>
  </div>
  <div
    *ngIf="item.children.length > 0"
    id="box{{ item.id }}"
    class="pl-3 list-group list-group-flush panel-collapse collapse {{
      item.selected ? 'show' : ''
    }}"
  >
    <div class="dropdown-box" style="position: absolute">
      <app-treeview-link
        #submenu
        [selected]="i.selected"
        (onSelect)="onChildrenSelected($event, i.id)"
        *ngFor="let i of item.children"
        [item]="i"
        [parent]="parent + ' > ' + item.description"
        (breadCrumb)="saveBc($event)"
      ></app-treeview-link>
    </div>
  </div>
</div>
